import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M1.48 13c-.28 0-.48-.229-.48-.498S1.2 12 1.48 12l7.02.004c.28 0 .5.229.5.498S8.78 13 8.5 13H1.48zm0 3c-.28 0-.48-.229-.48-.498S1.2 15 1.48 15l4.02.004c.28 0 .5.229.5.498S5.78 16 5.5 16H1.48zm17.374-6.854c-.001-.001-.002-.001-.003-.002l-5.997-5.998c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l5.146 5.146H1.501c-.28 0-.5.23-.5.5s.22.5.5.5h15.793l-5.147 5.147a.5003.5003 0 0 0 0 .707c.098.098.226.146.354.146s.256-.049.354-.146l5.997-5.998c.001-.001.002-.001.003-.002.098-.098.146-.226.146-.354s-.049-.256-.146-.354z',
  ],
  height: 20,
  width: 20,
});
